import { authenticatedRequest } from '@app/rest/rest.lib'

export type IFeatureFlagsResponse = {
  status: string
  featureFlags: Map<string, boolean>
}

export function getFeatureFlags() {
  return authenticatedRequest<IFeatureFlagsResponse>({
    method: 'get',
    url: `/api/v2/featureFlags`,
  })
}

export function setFeatureFlag(featureFlagId: string, enabled: boolean) {
  return authenticatedRequest<IFeatureFlagsResponse>({
    method: 'post',
    url: `/api/v2/featureFlag`,
    data: { feature: featureFlagId, enabled },
  })
}
